import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import Form from './Form';
import Footer from '../common/Footer';
import Header from '../common/Header';
import NavigationCard from './NavigationCard';

const PurchaseGiftCard = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');

  const [formData, setFormData] = useState({
    Amount: '',
  });

  const handleChange = (field) => (e) => {
    setFormData({
      ...formData,
      [field]: e.target.value
    });
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_END_POINT}/transaction/${localStorage.getItem('user_id')}/get-url`, {
        amount: formData.Amount,
        type: 'GiftCard',
      });

      if (response.data?.url) {
        window.location.href = response.data.url;
      } else {
        alert('No URL found in the response');
      }
    } catch (error) {
      console.error('Error getting URL:', error);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('user-access-token');
    navigate('/user/login');
  }

  useEffect(() => {
    const accessToken = localStorage.getItem('user-access-token');
    setUsername(localStorage.getItem('user_name'));
    if (accessToken) {
      navigate('/user/giftcard');
    } else {
      navigate('/user/login');
    }
  }, []);

  return (
    <div>
      <Header
        handleLogout={handleLogout}
      />

      <Form
        title={'Purchase Gift Card'}
        description={`Welcome Back ${username}`}
        fields={['Amount']}
        fieldValues={formData}
        handleSubmit={handleSubmit}
        handleChange={handleChange}
        suggestedAmount={['$ 20', '$ 50', '$ 100', '$ 200', '$ 500', '$ 1000']}
      />

      <div className='navigation-cards-container'>
        <NavigationCard title='Purchase Electricity' navigationUrl='/user/electricity' />
        <NavigationCard title='Redeem Gift Card' navigationUrl='/user/redeem' />
      </div>

      <Footer />
    </div>
  );
}

export default PurchaseGiftCard;
